// @ts-nocheck
import {AxiosError} from 'axios';
import {useInfiniteQuery, useQuery} from 'react-query';
import {residentApiWithAuth} from '../api/resident';
import {showErrorMessage} from '../service/flashMessage';
import {getCurrentUnitLink} from '../utils';
import getErrorMessage from '../utils/getErrorMessage';
import E_QUERY_NAMES from './query-names';

export function usePaginatedKeyLogsByUnit(queryParams: {status: string}) {
  const currentUnitId = getCurrentUnitLink()?.unit?.id;
  let url = `/keyLog/unit/${currentUnitId}?pageSize=${15}`;

  if(queryParams.status){
    url = `${url}&status=${queryParams.status}`;
  }
 console.log("url", url)
  return useInfiniteQuery(
    [E_QUERY_NAMES.KEY_LOGS + currentUnitId],
    async ({pageParam = 1}) => {
      const paginatedUrl = `${url}&pageNumber=${pageParam}`;

      const response = await residentApiWithAuth().get(paginatedUrl);
      const data = await response?.data;
      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.nextPage !== null) {
          return lastPage.pageNumber + 1;
        }
        return undefined;
      },
      onSuccess: (data) => {
        return data;
      },
      onError: (error: AxiosError) => {
        showErrorMessage('keylogs: ' + getErrorMessage(error));
      },
    },
  );
}

export function useKeyLog(logId: string) {
  return useQuery(
    E_QUERY_NAMES.KEY_LOG + logId,
    async () => {
      const {data} = await residentApiWithAuth().get(`/keyLog/${logId}`);
      return data?.data;
    },
    {
      onSuccess: (_) => {},
      onError: (error: AxiosError) => {
        showErrorMessage('keylogs - 2: ' + getErrorMessage(error));
      },
    },
  );
}
